/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Employee } from './Employee';
import {
    EmployeeFromJSON,
    EmployeeFromJSONTyped,
    EmployeeToJSON,
    EmployeeToJSONTyped,
} from './Employee';

/**
 * 
 * @export
 * @interface UpdateEmployeeResponse
 */
export interface UpdateEmployeeResponse {
    /**
     * 
     * @type {Employee}
     * @memberof UpdateEmployeeResponse
     */
    data: Employee;
}

/**
 * Check if a given object implements the UpdateEmployeeResponse interface.
 */
export function instanceOfUpdateEmployeeResponse(value: object): value is UpdateEmployeeResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateEmployeeResponseFromJSON(json: any): UpdateEmployeeResponse {
    return UpdateEmployeeResponseFromJSONTyped(json, false);
}

export function UpdateEmployeeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEmployeeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': EmployeeFromJSON(json['data']),
    };
}

  export function UpdateEmployeeResponseToJSON(json: any): UpdateEmployeeResponse {
      return UpdateEmployeeResponseToJSONTyped(json, false);
  }

  export function UpdateEmployeeResponseToJSONTyped(value?: UpdateEmployeeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EmployeeToJSON(value['data']),
    };
}

